export default __webpack_public_path__ + "static/media/info-icon.13428902.svg";